module.exports = __webpack_public_path__ + "img/b4.408ddef1.png";